import api from './http';
const base = '/service-cost-centers/quotation-requests/imports';
const target = (batchId, identifier) => `${base}/requests/${encodeURIComponent(batchId)}/${encodeURIComponent(identifier)}`;
export const QuotationImportsAPI = {
  upload: (batchId, identifier, file) => { const form = new FormData(); form.append('file', file); return api.post(target(batchId, identifier), form).then((r) => r.data); },
  list: (batchId, identifier) => api.get(target(batchId, identifier)).then((r) => r.data),
  read: (id) => api.get(`${base}/${encodeURIComponent(id)}`).then((r) => r.data),
  save: (id, review) => api.patch(`${base}/${encodeURIComponent(id)}`, review).then((r) => r.data),
  confirm: (id, payload) => api.post(`${base}/${encodeURIComponent(id)}/confirm`, payload, { timeout: 190000 }).then((r) => r.data),
  template: (batchId, identifier, format) => api.get(`${target(batchId, identifier)}/template/${format}`, { responseType: 'blob' }).then((r) => r.data),
  source: (id) => api.get(`${base}/${encodeURIComponent(id)}/source`, { responseType: 'blob' }).then((r) => r.data)
};
